import React, {  useState, useEffect,useRef } from 'react';
import axios from 'axios';
import Modal from '../Modal';
import { getUserId,aPIURL,auTHURL,getCustomerTypeId } from '../../utils/common';
import ReactPaginate from "react-paginate";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useReactToPrint } from 'react-to-print';
//import { useDownloadExcel } from "react-export-table-to-excel";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';



const CDeviceList = () => 
{
    const fileType ="xlsx";
    const tableRef = useRef(null);
    const API_URL=aPIURL();
    const AUTH_URL= auTHURL();
    const customer_type_id=getCustomerTypeId();
    const Account_ID = getUserId(); 

    const [userId, setUserId]  = useState({});
    const [custID, setCustID]  = useState('0');
    const [dIMEINo, setDIMEINo]  = useState('0'); 
    const [devName, setDevName]  = useState(""); 
    const [dID, setDID]  = useState('0');
    const [vCategoryID, setVCategoryID]  = useState('0');
    const [isLoading, setIsLoading] = useState(false);
    const [post, setPost] = useState([]);
    const [deviceData , setDeviceData]  =useState([]);
    const [subuserData , setSubuserData]  =useState([]);
    const [filteredDevicedata,setFilteredDevicedata ]  =useState([]);
    const [vCategoryData,setVCategoryData ]  =useState([]);
    const [showDetails,setShowDetails ]  = useState(false);
    
    const [showEditDriver,setShowEditDriver ]  = useState(false);
    const [showEditVehicle,setShowEditVehicle ]  = useState(false);     
    const [order, setOrder] = useState("ASC");
    const [number, setNumber] = useState(1); // No of pages
    const [postPerPage] = useState(10);
    const [statusId, setStatusId]= useState(0);
    const [sdate,setSdate]=useState();
    const [edate,setEdate]=useState();
    const [device,setDevice]=useState();
    const [showAddDetails,setShowAddDetails]= useState(false);
    const [statusData,setStatusData]= useState([]);
    const [dsubuserId,setDsubuserId]= useState();
    const [timeZoneData,setTimeZoneData]= useState([]);
    const [timeZoneId, setTimeZoneId]= useState('');
    const [groupData,setGroupData]= useState([]);
    const [groupId, setGroupId]= useState('1');
    let [isRelay,setIsRelay]=useState(0); 
    const [inputs, setInputs] = useState({});
    const [actionId,setActionId]= useState('2');
    const [cDisplay, setCDisplay]= useState('none');
    const adurls=API_URL;
   
 
  const sorting=(col)=>
  {

    try
    {
      if(order==="ASC")
      {
              const sorted=[...post].sort((a,b)=>
              a[col].toLowerCase() > b[col].toLowerCase() ? 1: -1
              );
              setPost(sorted);
              setOrder("DSC");
      }
      if(order==="DSC")
      {
              const sorted=[...post].sort((a,b)=>
              a[col].toLowerCase() < b[col].toLowerCase() ? 1: -1
              );
              setPost(sorted);
              setOrder("ASC");
      }
    }
    catch(error) 
    {
      console.log(error.message);
    }              
  }

useEffect(() => 
{
    if(customer_type_id == 3)
    {
        setCDisplay('block');            
    }
    FillGrid(0);        
  }, []);
  
  const lastPost = number * postPerPage;
  const firstPost = lastPost - postPerPage;
  const currentPost = post.slice(firstPost, lastPost);
  const PageCount = Math.ceil(post.length / postPerPage);
 
  //Filter over grid  
  const FilterGrid=()=>
  {
    
    const searchparams = JSON.stringify({
      "accountid": Account_ID,
      "imeiNumber": "",
      "deviceName": device,
      "mobileNumber": "",
      "timeZone": "",
      "status": "",
      "groupID": 0,
      "model": "",
      "startExpirationDate":sdate,
      "endExpirationDate": edate,
      "startActivatedDate": "",
      "endActivatedDate": "",
      "orderBy": ""
    });

    //alert(searchparams);
    setPost([]);
    axios.post(API_URL+'GpsSearchDeviceAdvance/', searchparams, {  
      "headers":{"content-type": "application/json",},})
    .then(function (response) 
    {         
         setPost(response.data.data)      
        console.log(response.data.data);
    })
    .catch(function (error) 
    {
         toast.info("No data found !");
    });
  }

const FillCustomerDropDown=()=>
{   
    const curls=API_URL+`GpsCustomerAllChildList/?TypeID=0&ParentID=${Account_ID}`;  
    
    axios.post(curls).then(response => {  
    console.log(response.data.data);                           
    setSubuserData(response.data.data);
     }).catch(function(error){console.log(error.message);});   
    
}
const ResetList=()=>
{
      setDevice("");
      setSdate("");
      setEdate("");
      FillGrid(0);
}
const DchangeHandler=(e)=>
{
      setDevice(e.target.value)
}
const SDatechangeHandler = (e) => 
{   
         setSdate(e.target.value)
} 
const closeAssignDeviceModal = () => {
            
      setShowAddDetails(false);
      setShowDetails(false);          
}
const EDatechangeHandler = (e) => 
{   
      setEdate(e.target.value)
} 
const ChangePage = ({ selected }) => {
        
       setNumber(selected+1);
};
const ChangeDGroup = (e) => {

            setGroupId(e.target.value);        
}           
const handleChange = (event) => 
{  
    setIsRelay(event.target.value);
};
const showDetailsModal = (index) => 
{
        const d_Id = index;
                                   
        const urls=API_URL+`GetDeviceDetails/${d_Id}/`;    
        //alert(urls)
        axios.post(urls).then(response =>
        {                  
                setFilteredDevicedata(response.data.data);
        }).catch(function(error) 
        {  
            console.log(error.message); 
        });
            
        setShowDetails(true);  
        setShowEditDriver(false);
        setShowEditVehicle(false);              
}


const ChangeDSubuserId = (e) => {    

        setDsubuserId(e.target.value);       
}
       
const closeModal = () => 
{
        setShowDetails(false);        
        setShowEditDriver(false);
        setShowEditVehicle(false);       
}
const FillGrid=(Type_ID)=>
{
    const Account_ID = getUserId();    
    setUserId(Account_ID);
    setIsLoading(true);
    const curls=API_URL+`GpsDeviceList/?AccountID=${Account_ID}&TypeID=${Type_ID}`;  
    //alert(curls);
    setPost([]);
    axios.post(curls).then(response => 
    {    
        setIsLoading(false);             
        setPost(response.data.data)
        console.log(response.data.data);
        console.log("-------------------device-----------------------");
        console.log(response.data.data);  
    }).catch(function(error)
    {
        setIsLoading(false);
        console.log(error.message);
    }
    );
}
const onClickAssign = () => {
    
    inputs.DModel = "GPS-V5";
    
    if(dsubuserId ==='0')
    {
        //alert(dsubuserId);
        toast.error("Please Select Sub User.");
        return;
    }       
  else  
  {
        const adurls=API_URL+`GpsDeviceSAssign/?IMEINumber=${inputs.DIMEI}&SubUserId=${dsubuserId}`;       
    
        axios.post(adurls).then(function (response) 
        {    
              
              console.log(response.data.validStatus);
              if(!response.data.validStatus)
               {
                     console.log(response.data);
                     toast.error(response.data.message);
               }
               else
               {
                      FillGrid(0);  
                      toast.success(response.data.message);
                     //handleAddCustomerClear();                                
              }      

        }).catch(function(error){
        
        console.log(error.message);}
      );            
              
}


}
const handleAddDeviceClear=()=>
  {
       
        setGroupId('1'); 
        setTimeZoneId(''); 
        setDsubuserId(0);  
        setDID('0');          
        setDeviceData([]);    
        
        //bind device details grid
        //bindDeviceDetails();          
  }

const changeAddDeviceHandler = (e) => {

  if(e.target.name==='DevMobile')
  {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) 
        {
             const name = e.target.name;
             //alert(name);
             const value = e.target.value;
              setInputs(values => ({...values, [name]: value}))
        }
        else
        {
          setInputs(values => ({...values, ['DevMobile']: ""}))
              
        }
        
  }
  else
  {
                const name = e.target.name;
                const value = e.target.value;
                setInputs(values => ({...values, [name]: value}))
  }
}
const handleEdit=(index) => {
            
    const D_Id = index;                   
    const urls = API_URL+`GetDeviceDetails/${D_Id}/`;
    //alert(urls);  
    
    axios.post(urls).then(response => 
    {
        console.log("---------------start---------------");
        console.log(response.data.data[0]);                  
               
        setDID(response.data.data[0].id);  
        setGroupId(response.data.data[0].groupID); 
        setTimeZoneId(response.data.data[0].timeZone);          
        console.log(response.data.data[0].id);         
        //inputs       
        inputs.DIMEI= response.data.data[0].iemiNumber;
        inputs.DModel= response.data.data[0].model;
        inputs.DevMobile= response.data.data[0].mobileNumber;
        setDsubuserId(response.data.data[0].subUserID);   
    
  });                                                        
   
        FillCustomerDropDown();
        setShowAddDetails(true);
        setShowDetails(false);
                  
}
const exportStatus = e => {
 
    const value = e.target.value;
    setStatusId(e.target.value);
    FillGrid(value);
  }
const exportToCSV=()=>
    {
      const newPost = post.map(({ groupName,timeZone,deviceID,model,createdBy, ...rest }) => rest);
       const ws= XLSX.utils.json_to_sheet(newPost);        
       var wscols = [
          {wch:5} ,
          {wch:20},
          {wch:20},
          {wch:20},
          {wch:20},
          {wch:20},
          {wch:20},         
          {wch:20}          
      ];
   
      var wsrows = [
         {hpx: 30}
      ];
      
      ws['!cols'] = wscols;
      ws['!rows']=wsrows;
     
      let Heading = [['S.No.','Device Name',	'Device IMEI',	'SIM Number',	'Activation Date',	'Expiration Date',	'Status']];
      const wb={Sheets:{Device:ws},SheetNames:["Device"]};
      XLSX.utils.sheet_add_aoa(ws, Heading);     
      const excelBuffer= XLSX.write(wb,{bookType:"xlsx",type:"array"});
      const data= new Blob([excelBuffer],{type:fileType});
      FileSaver.saveAs(data,"AvtDeviceReport"+".xlsx");     
  
  }
const exportDownload = e => 
{  
  
  const value = e.target.value; 

  if(value=="Excel")
  {
    exportToCSV();     
  }
  if(value=="PDF")
  {
        handlePrint(null, () => tableRef.current);
  }
}
//const { onDownload } = useDownloadExcel({
 // currentTableRef: tableRef.current,
  //filename: "Device Details",
  //sheet: "Devices"
//});

const handlePrint = useReactToPrint({
  documentTitle: "Device Details",
  onBeforePrint: () => console.log("before printing..."),
  onAfterPrint: () => console.log("after printing..."),
  removeAfterPrint: true,
});

const styles = {
headsection: {
    backgroundColor:"black", color:"white",textAlign:"center"
},
tcaption: {
    textAlign:"left",fontWeight:"bold","vertical-align": "middle",width:"15%"
}
}

return (
  <>
  {/*Assign Device Model*/}
  <Modal isOpen={showAddDetails} >  
  <div class="modal-header">
  <h5 className='modal-title'>Assign Device</h5>
  <button type="button" class="btn-close" onClick={closeAssignDeviceModal}></button>
  </div>
  <div class="modal-body">                           
  <div class="row">
  <div class="col-sm-6 col-md-6 form-group">
		Device IMEI<span style={{color:"red"}}>&nbsp;*</span>        
    <input name="DIMEI"  type="text" required="required" disabled  className="form-control" maxLength={16} value={inputs.DIMEI} onChange={changeAddDeviceHandler} ></input>
		</div>		
		<div class="col-sm-6 col-md-6 form-group">
		SIM Number
    <input name="DevMobile" type="text" required="required" disabled className="form-control" maxLength={13} value={inputs.DevMobile} onChange={changeAddDeviceHandler} ></input>
		</div>
	</div>
  	<div class="row">
		<div class="col-sm-6 col-md-6 form-group">
		Model<span style={{color:"red"}}>&nbsp;*</span>
    <select className="form-control" name="DGroup" disabled value={inputs.DModel}   >
    <option value={"GPS-V5"}>GPS-V5</option>               
    </select>
    </div>
		<div class="col-sm-6 col-md-6 form-group">
		SubUser<span style={{color:"red"}}>&nbsp;*</span>
    <select className="form-control slct" name="DSubuser" value={dsubuserId} onChange={ChangeDSubuserId} >
       <option value={0}>Select SubUser</option>
    {subuserData.map((e, key) => {
    return <option key={key} value={e.accountID}>{e.companyName} ({e.userName}) </option>;
    })}
    </select>       
   	</div>
    </div>
    <div class="col-sm-12 col-md-12 form-group">
    <center>
        <button type="submit" id="Save" onClick={onClickAssign} className="btn btn-primary2">Assign </button>                
    </center>
    </div>
	</div>
  </Modal>
           
  <Modal isOpen={showDetails} >  
  <div  class="modal-header">
            <h5 className='modal-title'>Device Details</h5>
            <button type="button" class="btn-close" onClick={closeModal}></button>
            </div>
            <div class="modal-body">                      
            <div class="row">
            <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px" }}><b>Device Details </b> </span>             
            <table >
            {filteredDevicedata.map(devdata1 => (
            <tr key={devdata1.id}>
                <td>                    
                <div class="row">             
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Name : </b>        
                {devdata1.deviceName}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Model : </b>       
                {devdata1.model}
                </div>
                <div class="col-sm-6 col-md-4 form-group"> &nbsp;
                <b> IMEI Number : </b>      
                {devdata1.iemiNumber}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Mobile Number : </b>       
                {devdata1.mobileNumber}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Group : </b>        
                {devdata1.groupName}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Time-Zone : </b>      
                {devdata1.timeZone}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Activation Date : </b>        
                {devdata1.activationDate}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Expiration Date : </b>       
                {devdata1.expirationDate}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Status : </b>        
               {devdata1.status}                   
                </div>                    
                </div>               
                </td>                            
            </tr>
             ))}
            </table>
            
            <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px"}}><b>Driver Details </b> </span> 
            <table >
            {filteredDevicedata.map(devdata1 => (
                
            <tr key={devdata1.id}>
                <td>                    
                <div class="row">                
               
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Driver Number : </b>      
                {devdata1.driverName}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Father Name : </b>       
                {devdata1.fatherName}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Contact Number : </b>        
                {devdata1.contactNumber}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> License Number : </b>       
                {devdata1.licenceNumber}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> License From : </b>        
                {devdata1.licenceIssueFrom}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> License Validity : </b>      
                {devdata1.licenceValidity}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Address : </b>        
                {devdata1.address}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Identity Number : </b>       
                {devdata1.identityNumber}
                </div>               
                </div>    
                </td>                            
            </tr>
             ) )
            }
            </table>
            
            <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px" }}><b>Vehicle Details </b> </span> 
            <table >
            {filteredDevicedata.map(devdata1 => (
            <tr key={devdata1.id}>
                <td>                    
                <div class="row">
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Vehicle Number : </b>      
                {devdata1.vehicleNumber}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> VIN : </b>       
                {devdata1.vin}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Engine Number : </b>        
                {devdata1.enginNumber}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Vehicle Brand : </b>       
                {devdata1.vehicleBrand}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Vehicle Model : </b>        
                {devdata1.vehicleModel}
                </div>               
                </div>
                </td>                            
            </tr>
             )             
            )
            }
            </table>
            </div>
            </div>
           
  </Modal>
           
          
      <div className="top-bar clearfix">
      <div className="row">
         <div className="col-md-4">
            <h2> Devices </h2>        
         </div>
          <div className="col-md-8 text-right">                 
                 
            <select onChange={exportStatus} className="btn btn-primary" name="Export"  value={statusId} >             
            <option value={"0"}>All</option>  
            {/* <option value={"3"}>Expired</option>*/}
            <option value={"1"}>Enabled</option>  
            <option value={"2"}>Disabled</option>                   
            </select> 
            <select onChange={exportDownload}  className="btn btn-primary" name="Download"   >
            <option value={"Download"}>Download</option>    
            <option value={"Excel"}>Excel</option>    
            <option value={"PDF"}>PDF</option>                     
            </select>            
          </div>
        </div>
      </div>
    
 {/* Filter data start  */}
    
  <div className="container-fluid p-3">
  <div class="card mb-3 shadow no-border border-0">
  <div class="card-body">
    <div class="row align-items-end">  
    <div class="col-sm-3 col-lg-2">Device Name<input type="text" class="form-control" tabindex="1" id="txtTripNumber" value={device} onChange={DchangeHandler} maxlength="50"/>
    </div>
      <div class="col-sm-3 col-lg-2">Start Expiry Date
      <input class="form-control" aria-label="SDate" onChange={SDatechangeHandler} value={sdate} type="date" />
      </div> 
      <div class="col-sm-3 col-lg-2">End Expiry Date
      <input class="form-control" aria-label="EDate" onChange={EDatechangeHandler} value={edate}  type="date" />
      </div>        
      <div class="col-sm-4 col-lg-2">
      <button type="button" class="btn btn-primary2 mt-20" tabindex="6" id="btnTripAdvancedSearchNew" onClick={FilterGrid} >Search</button>
      <button type="button" class="btn btn-secondary mt-20" id="btnTripResetAdvancedSearchNew" tabindex="7" onClick={ResetList}>Reset
      </button></div>
      </div>
    
  </div></div>
  {/* Filter data end  */}
    <div class="card-body p-0">
       <table ref={tableRef} class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
        <thead>
            <tr>
                <th style={{textAlign:"center"}} width="5%" >S.No.</th>  
                <th width="15%" onClick={()=>sorting("deviceName") } style={{textAlign:"center","cursor": "pointer"}}>Device Name  &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>                
                <th width="15%" onClick={()=>sorting("imeiNumber") } style={{textAlign:"center","cursor": "pointer"}}>Device IMEI  &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="15%" onClick={()=>sorting("mobileNo") } style={{textAlign:"center","cursor": "pointer"}}>SIM Number &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="15%" onClick={()=>sorting("activationDate") } style={{textAlign:"center","cursor": "pointer"}}>Activation Date &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="15%" onClick={()=>sorting("expirationDate") } style={{textAlign:"center","cursor": "pointer"}}>Expiration Date &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="10%" onClick={()=>sorting("status") } style={{textAlign:"center","cursor": "pointer"}}>Status &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="10%"  onClick={()=>sorting("id") }  style={{textAlign:"center","cursor": "pointer"}}>Action</th>
            </tr>
        </thead>
        <tbody>
        {currentPost.map((Val) => {
                 
            return (
            <>                  
            <tr key={Val.id}>
              <td style={{textAlign:"center"}}>{Val.id}</td>
              <td>{Val.deviceName}</td>              
              <td>{Val.imeiNumber}</td>
              <td style={{textAlign: "center"}}>{Val.mobileNo}</td>
              <td style={{textAlign:"center"}}>{Val.activationDate}</td>
              <td style={{textAlign:"center"}}>{Val.expirationDate}</td>
              <td style={{textAlign:"center"}}>{Val.status}</td>
              <td style={{textAlign:"center", fontSize:"16px"}}>
              <i onClick={() => showDetailsModal(Val.deviceID)} style={{ color:"green", cursor:'pointer'}} className="fa-solid fa-list" title="View Details"></i>
              &nbsp;&nbsp; <i onClick={() => handleEdit(Val.deviceID)} style={{ color:"#FD0691", cursor:'pointer', display: cDisplay}}  className="fa-solid fa-pen-to-square" title="Assin to SubUser"></i>
              </td>              
            </tr>
            </>
                );
              })}         
            </tbody>
        </table>
        <ReactPaginate previousLabel={"<<"}  nextLabel={">>"}  pageCount={PageCount} onPageChange={ChangePage}  disableInitialCallback={true}
            initialPage={0} containerClassName={'pagination justify-content-end'} pageClassName={'page-item'} pageLinkClassName={'page-link'}
            previousClassName={'page-item'} previousLinkClassName={'page-link'} nextClassName={'page-item'} nextLinkClassName={'page-link'}
            breakClassName={'page-item'} breakLinkClassName={'page-link'} activeClassName={'active'}></ReactPaginate>
            </div>  </div> 
            <ToastContainer position="bottom-right" autoClose={4000} theme="light"/>  
            
        </>
    );}

export default CDeviceList;
